document.addEventListener("DOMContentLoaded", function() {
  console.log("Find Your Voice: Activated");

// --- 1. OVERLAY TOGGLES ---
function bindOverlay(id) {
  const overlay = document.getElementById(id);
  if (!overlay) return;

  document.querySelectorAll(`[data-open="${id}"]`).forEach(btn => {
    btn.onclick = (e) => {
      e.preventDefault();

      // Open overlay
      overlay.classList.add("is-open");
      console.log(`🏠 Entering Overlay: ${id}`);

      // Prefill WMR fields from clicked issue card
      if (id === "wmrOverlay") {
        const issueEl = overlay.querySelector("#issue");
        const positionEl = overlay.querySelector("#position");
        const contentTypeEl = overlay.querySelector("#contentType");
        const toneEl = overlay.querySelector("#tone");
        const notesEl = overlay.querySelector("#notes");

        if (issueEl && btn.dataset.issue) issueEl.value = btn.dataset.issue;
        if (positionEl && btn.dataset.position) positionEl.value = btn.dataset.position;
        if (contentTypeEl && btn.dataset.content) contentTypeEl.value = btn.dataset.content;
        if (toneEl && btn.dataset.tone) toneEl.value = btn.dataset.tone;
        if (notesEl && btn.dataset.notes) notesEl.value = btn.dataset.notes;

        // Fire change events in case anything else listens to these fields later
        if (issueEl && btn.dataset.issue) issueEl.dispatchEvent(new Event("change", { bubbles: true }));
        if (positionEl && btn.dataset.position) positionEl.dispatchEvent(new Event("change", { bubbles: true }));
        if (contentTypeEl && btn.dataset.content) contentTypeEl.dispatchEvent(new Event("change", { bubbles: true }));
        if (toneEl && btn.dataset.tone) toneEl.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // Store FYV context from the opener if available.
      // This does not require visible dropdowns inside FYV.
      if (id === "fmvOverlay") {
        if (btn.dataset.issue) overlay.dataset.issue = btn.dataset.issue;
        if (btn.dataset.topic) overlay.dataset.topic = btn.dataset.topic;
      }
    };
  });

  overlay.querySelectorAll("[data-close]").forEach(c => {
    c.onclick = () => overlay.classList.remove("is-open");
  });
}
  
  bindOverlay("wmrOverlay");
  bindOverlay("fmvOverlay");

  // --- 2. FYV TOPIC -> OPINION MAP ---
  // Quick hack data source for Find Your Voice pill rendering.
  const FYV_DATA = {
    "Epstein Files": [
      "Release the files",
      "Protect the victims",
      "Prosecute the powerful",
      "Stop the political spin",
      "Follow the money"
    ],
    "Supreme Court": [
      "Enforce ethics rules",
      "Limit lifetime power",
      "Defend court independence",
      "Expose donor influence"
    ],
    "Iran War": [
      "Stop another war",
      "Demand a real explanation",
      "Prevent a nuclear threat",
      "Count the cost at home"
    ]
  };

  // --- 3. DUAL-TOOL AI LOGIC ---
  const tools = [
    { 
      id: 'wmrOverlay', 
      endpoint: 'https://us-central1-fetch-this-45a3c.cloudfunctions.net/writeMyRepChat', 
      isVoice: false 
    },
    { 
      id: 'fmvOverlay', 
      endpoint: 'https://us-central1-fetch-this-45a3c.cloudfunctions.net/findMyVoice', 
      isVoice: true 
    }
  ];

  tools.forEach(tool => {
    const overlay = document.getElementById(tool.id);
    if (!overlay) return;

    const getEl = (selector) => overlay.querySelector(selector);

    const el = {
      // Buttons
      start: getEl(tool.isVoice ? "#startBtnVoice" : "#startBtn"),
      send: getEl(tool.isVoice ? "#sendBtnVoice" : "#sendBtn"),
      draft: getEl(tool.isVoice ? "#draftBtnVoice" : "#draftBtn"),

      // Output Sections
      chatWindow: getEl("#chat"),
      typingBar: document.getElementById("typing"),
      chatSection: getEl("#secChat"),
      resultBox: getEl("#preview"),
      resultSection: getEl("#secPreview"),
      inputsSection: getEl("#secInputs"),

      // Input Fields
      issue: getEl("#issue"),
      tone: getEl("#tone"),
      notes: getEl("#notes"),
      position: getEl("#position"),
      contentType: getEl("#contentType"),
      chatInput: getEl("#chatInput"),

      // FYV pill containers
      topicRow: getEl("#fmvTopicRow"),
      opinionRow: getEl("#fmvOpinionRow")
    };

    if (!el.start) return;

    let messages = [];

    // FYV state
    let selectedTopic = "";
    let selectedOpinion = "";

    function renderFYVTopics() {
      if (!tool.isVoice || !el.topicRow) return;

      const topics = Object.keys(FYV_DATA);
      const preferredTopic = overlay.dataset.topic && FYV_DATA[overlay.dataset.topic]
        ? overlay.dataset.topic
        : topics[0];

      selectedTopic = preferredTopic;

      el.topicRow.innerHTML = topics.map(topic => `
        <button 
          type="button"
          class="pill-btn-topic ${topic === selectedTopic ? "is-selected" : ""}" 
          data-topic="${topic}">
          ${topic}
        </button>
      `).join("");

      renderFYVOpinions(selectedTopic);
    }

    function renderFYVOpinions(topic) {
      if (!tool.isVoice || !el.opinionRow || !FYV_DATA[topic]) return;

      const opinions = FYV_DATA[topic];
      selectedOpinion = opinions[0] || "";

      el.opinionRow.innerHTML = opinions.map((opinion, index) => `
        <button 
          type="button"
          class="pill-btn-opinion ${index === 0 ? "is-selected" : ""}" 
          data-opinion="${opinion}">
          ${opinion}
        </button>
      `).join("");
    }

    if (tool.isVoice) {
      renderFYVTopics();

      if (el.topicRow) {
        el.topicRow.addEventListener("click", (e) => {
          const btn = e.target.closest("[data-topic]");
          if (!btn) return;

          selectedTopic = btn.dataset.topic || "";

          el.topicRow.querySelectorAll(".pill-btn-topic").forEach(pill => {
            pill.classList.remove("is-selected");
          });

          btn.classList.add("is-selected");
          renderFYVOpinions(selectedTopic);
        });
      }

      if (el.opinionRow) {
        el.opinionRow.addEventListener("click", (e) => {
          const btn = e.target.closest("[data-opinion]");
          if (!btn) return;

          selectedOpinion = btn.dataset.opinion || "";

          el.opinionRow.querySelectorAll(".pill-btn-opinion").forEach(pill => {
            pill.classList.remove("is-selected");
          });

          btn.classList.add("is-selected");
        });
      }
    }

    async function callAI(mode, userInput = "") {
      console.log(`📡 Signal Sent: ${tool.id} [Mode: ${mode}]`);

      if (el.typingBar) el.typingBar.style.display = "block";

      try {
        const payload = tool.isVoice
          ? {
              issue: overlay.dataset.issue || el.issue?.value || "Abuse of Power",
              topic: selectedTopic,
              opinion: selectedOpinion,
              notes: el.notes?.value || "",
              mode: mode,
              messages: messages
            }
          : {
              issue: el.issue?.value || "",
              tone: el.tone?.value || "",
              notes: el.notes?.value || "",
              position: el.position?.value || "",
              contentType: el.contentType?.value || "letter",
              mode: mode,
              messages: messages
            };

        const res = await fetch(tool.endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        if (!res.ok) throw new Error(`Server Error: ${res.status}`);

        const data = await res.json();
        console.log("✔️ Raw Data Received:", data); 
        
        const aiText = data.reply || data.draft || data.analysis || "";

        if (mode === "chat") {
          messages.push({ role: "assistant", content: aiText });
          if (el.chatWindow) {
            const div = document.createElement("div");
            div.style.margin = "10px 0";
            div.innerHTML = `<b>AI AGENT:</b> ${aiText}`;
            el.chatWindow.appendChild(div);
            el.chatWindow.scrollTop = el.chatWindow.scrollHeight;
          }
        } else {

// --- FIND YOUR VOICE ---          
          // if (el.resultBox) el.resultBox.innerHTML = aiText.replace(/\n/g, '<br>');

          if (tool.isVoice) {

            let parsed;

            try {
              parsed = JSON.parse(aiText);
            } catch {
              el.resultBox.innerHTML = aiText;
              return;
            }

            const issue = overlay.dataset.issue || "Issue";
            const topic = selectedTopic || "";
            const opinion = selectedOpinion || "";
            const today = new Date().toLocaleDateString();

            el.resultBox.innerHTML = `
              <div class="fyv-kit fyv-print">
                <!-- TOP ANCHOR ROW -->
                <div class="fyv-row fyv-row--anchor">
                  <div>STATEMENT FASHION</div>
                  <div>FIND YOUR VOICE</div>
                  <div>${issue}</div>
                  <div>${topic}</div>
                </div>
                <!-- SUMMARY + VALUES -->
                <div class="fyv-row fyv-row--summary">
                  <p class="fyv-snapshot">${parsed.snapshot || ""}</p>
                  <p class="fyv-values">${parsed.valuesInsight || ""}</p>
                </div>
                <!-- MAIN CONTENT -->
                <div class="fyv-row fyv-row--split">
                  <div class="fyv-left">
                    <div class="fyv-block">
                      <h4>CORE POINTS</h4>
                      <ul>
                        ${(parsed.points || []).slice(0,3).map(p => `<li>${p}</li>`).join("")}
                      </ul>
                    </div>
                    <div class="fyv-block">
                      <h4>BULLETS</h4>
                      <ul>
                        ${(parsed.ammo || []).slice(0,3).map(a => `<li>${a}</li>`).join("")}
                      </ul>
                    </div>
                    <div class="fyv-block">
                      <h4>RETORT CARD</h4>
                      ${(parsed.retorts || []).slice(0,2).map(r => `
                        <div class="fyv-retort">
                          <div class="fyv-push">${r.pushback}</div>
                          <div class="fyv-response">${r.response}</div>
                        </div>
                      `).join("")}
                    </div>
                  </div>
                  <!-- RIGHT SIDE -->
                  <div class="fyv-right">
                    <div class="fyv-quote">${parsed.quote || ""}</div>
                    <div class="fyv-block fyv-block--tight">
                      <h4>POSTER</h4>
                      <div class="fyv-slogan">${parsed.slogan || ""}</div>
                    </div>
                    <div class="fyv-block fyv-block--tight">
                      <h4>RETORT</h4>
                      ${(parsed.retorts || []).slice(0,1).map(r => `
                        <div class="fyv-retort">
                          <div class="fyv-push">${r.pushback}</div>
                          <div class="fyv-response">${r.response}</div>
                        </div>
                      `).join("")}
                    </div>
                  </div>
                </div>  
                <!-- FOOTER -->
                <div class="fyv-row fyv-row--footer">
                  <div>StatementFashion.us</div>
                  <div>${today}</div>
                  <div>${opinion}</div>
                </div>
              </div>
            `;
          } else {
            el.resultBox.innerHTML = aiText.replace(/\n/g, '<br>');
          }
          if (el.resultSection) el.resultSection.style.display = "block";
          el.resultSection?.scrollIntoView({ behavior: "smooth" });
        }
      } catch (err) {
        console.error("❌ Critical Failure:", err);
        if (el.chatWindow) el.chatWindow.innerHTML += `<div style="color:red">Error: ${err.message}</div>`;
        if (!el.chatWindow && el.resultBox) el.resultBox.innerHTML = `<div style="color:red">Error: ${err.message}</div>`;
      } finally {
        if (el.typingBar) el.typingBar.style.display = "none";
      }
    }

    // --- EVENT BINDING ---
    el.start.onclick = (e) => {
      e.preventDefault();
      messages = [];

      // FYV now skips chat and goes straight to output.
      if (tool.isVoice) {
        callAI("draft");
        return;
      }

      if (el.chatWindow) el.chatWindow.innerHTML = "";
      if (el.chatSection) el.chatSection.style.display = "block";
      el.chatSection?.scrollIntoView({ behavior: "smooth" });
      callAI("chat");
    };

    if (el.send) {
      el.send.onclick = (e) => {
        e.preventDefault();
        const val = el.chatInput?.value.trim();
        if (val) {
          const uB = document.createElement("div");
          uB.innerHTML = `<b>You:</b> ${val}`;
          if (el.chatWindow) el.chatWindow.appendChild(uB);
          messages.push({ role: "user", content: val });
          el.chatInput.value = "";
          callAI("chat", val);
        }
      };
    }

    if (el.draft) {
      el.draft.onclick = (e) => {
        e.preventDefault();
        callAI("draft");
      };
    }

// --- BIND EXPORT & COPY ACTIONS ---
    if (window.WMRExport) {
      window.WMRExport.bind({
        container: overlay, 
        getText: () => el.resultBox ? el.resultBox.innerText : "",
        setStatus: (msg, kind) => {
          console.log(`Export ${kind}: ${msg}`);
          // Show the inline confirmation box on success
          if (kind === "info" && msg.includes("Exported")) {
            const confirmBox = overlay.querySelector("#exportInlineConfirm");
            if (confirmBox) confirmBox.hidden = false;
          }
        }
      });
    }

  }); // This closes the tools.forEach loop

// --- STATE DROPDOWN -> FIND YOUR OFFICIALS PAGE ---
const stateSelect = document.getElementById("stateSelect");
const findOfficialsLink = document.getElementById("findOfficialsLink");

if (stateSelect && findOfficialsLink) {
  const baseUrl = "/pages/find-your-government-representatives-and-elected-officials";

  // initialize button state
  findOfficialsLink.href = baseUrl;
  findOfficialsLink.classList.add("is-disabled");

  stateSelect.addEventListener("change", () => {
    const state = stateSelect.value;

    if (!state) {
      findOfficialsLink.href = baseUrl;
      findOfficialsLink.classList.add("is-disabled");
      return;
    }

  const targetUrl = `${baseUrl}?state=${encodeURIComponent(state)}#fyoResultsHeading`;

    findOfficialsLink.href = targetUrl;
    findOfficialsLink.classList.remove("is-disabled");
  });
}
// --- ISSUE CAROUSEL (REUSES FYO FRAMEWORK) ---
const issueCarousel = document.getElementById('issue-carousel');

if (issueCarousel) {
  const wrapper = issueCarousel.parentElement;
  const prevBtn = wrapper.querySelector('.nav-btn.prev');
  const nextBtn = wrapper.querySelector('.nav-btn.next');

  function scrollIssueCarousel(direction) {
    const card = issueCarousel.querySelector('.official-card');
    if (!card) return;

    const gap = 16;
    const scrollAmount = (card.offsetWidth + gap) * direction;

    issueCarousel.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }

  function updateIssueNavButtons() {
    const scrollLeft = issueCarousel.scrollLeft;
    const maxScroll = issueCarousel.scrollWidth - issueCarousel.clientWidth;

    if (prevBtn) prevBtn.disabled = scrollLeft <= 5;
    if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 5;
  }

  if (prevBtn) prevBtn.addEventListener('click', () => scrollIssueCarousel(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => scrollIssueCarousel(1));

  issueCarousel.addEventListener('scroll', updateIssueNavButtons);
  updateIssueNavButtons();
}
}); // This closes the DOMContentLoaded listener